// extracted by mini-css-extract-plugin
module.exports = {"overlay":"upload-overlay_overlay__cy2va","frame":"upload-overlay_frame__h9KHS","text":"upload-overlay_text__IiQAq"};